import { render, staticRenderFns } from "./ElementAccordion.vue?vue&type=template&id=2f80ca3b&"
import script from "./ElementAccordion.vue?vue&type=script&lang=js&"
export * from "./ElementAccordion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports